import { createContext, useEffect, useState } from "react";
import { DisplayProfile } from "../Models/User";
import { useNavigate } from "react-router-dom";
import { RegisterClientMobile } from "../Services/AuthService";
import { toast } from "react-toastify";
import React from "react"; 
import apiService from "../Services/apiService";

type UserContextType = {
  userdisplay: DisplayProfile | null;
  token: string | null;
  RegisterClientMobile: (username: string, mobile: string) => void;
  logout: () => void;
  isLoggedIn: () => boolean;
  isAdminLoggedIn: () => boolean;
  isClientLoggedIn: () => boolean;
};
type Props = { children: React.ReactNode };
const UserContext = createContext<UserContextType>({} as UserContextType);
export const UserProvider = ({ children }: Props) => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(null);
  const [userdisplay, setUser] = useState<DisplayProfile | null>(null);
  const [isReady, setIsReady] = useState(false);
 
  useEffect(() => {
    const module = localStorage.getItem("user-module");
  
   if (module) {
   const userObj = {
        username: "Ed",
        email: "",
        mobile:String( module),
        pass: "",
        kind:Number( module),
        id:"1"
      };
       setUser(userObj);
}
    // const token =
    //   module === "1"
    //     ? localStorage.getItem("admntoken")
    //     : localStorage.getItem("shptoken");
    // if (
    //   user &&
    //   (module === "1"
    //     ? localStorage.getItem("admntoken")
    //     : localStorage.getItem("shptoken"))
    // ) {
    //   setUser(JSON.parse(user));
    //   setToken(token);
    //   axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    // }
    setIsReady(true);
  }, []);

  const registerClientMobile = async (username: string, mobile: string) => {
    const result = await apiService.fetchData("api/VertifyClientMobile", {
      Mobile: mobile,
      Name: username,
    });

    if (result.isOk && Array.isArray(result.data)) {
      localStorage.setItem("user-module", module.toString());
      const userObj = {
        username: result?.data.data.displayName,
        email: "",
        mobile: mobile,
        pass: "",
        kind: 1,
        id: result?.data.data.id,
      };
      localStorage.setItem("user-client", JSON.stringify(userObj));
      localStorage.setItem("clienttoken", result?.data.data.token);

      setToken(result?.data.data.token!);
      toast.success("Login Success!");
      // navigate("admin/dashboard");
      setUser(userObj!);
    } else {
      toast.error(result?.data.errAr);
      localStorage.setItem("clienttoken", ""); // Set to an empty array if no valid data
    }

    // await RegisterClientMobile(username, mobile)
    //   .then((res) => {
    //     if (res) {
    //       if (res?.data.isOk === true) {
    //         localStorage.setItem("user-module", module.toString());
    //         const userObj = {
    //           username: res?.data.data.displayName,
    //           email: "",
    //           mobile:mobile,
    //           pass:"",
    //           kind:1,
    //           id: res?.data.data.id,
    //         };
    //           localStorage.setItem("user-client", JSON.stringify(userObj));
    //           localStorage.setItem("clienttoken", res?.data.data.token);

    //         setToken(res?.data.data.token!);
    //         toast.success("Login Success!");
    //        // navigate("admin/dashboard");
    //         setUser(userObj!);

    //       } else {
    //         toast.error(res?.data.errAr);
    //        localStorage.setItem("clienttoken", "");
    //       }
    //     }
    //   })
    //   .catch((e) => {toast.warning("Server error occured");    localStorage.setItem("clienttoken", "");});
  };

  const isLoggedIn = () => {
    return !!userdisplay;
  };
 const isAdminLoggedIn = () => {
    return localStorage.getItem("user-server")!=null?true:false;
  };
  const isClientLoggedIn = () => {
    return localStorage.getItem("user-client")!=null?true:false;
  };
  const logout = () => {
    const module = localStorage.getItem("user-module");
    setUser(null);
    setToken("");
     localStorage.removeItem("user-module");
    if (module!=null && module === "1") {
      localStorage.removeItem("user-client");
      localStorage.removeItem("clienttoken");
        navigate("branches");
    } else {
      localStorage.removeItem("user-admin");
      localStorage.removeItem("admintoken"); 
       navigate("admin/login");
    } 
  };
  // hooks/useIdleLogout.ts



  return (
    <UserContext.Provider
  value={{
    userdisplay,
    token,
    logout,
    isLoggedIn,
    RegisterClientMobile: registerClientMobile,
    isAdminLoggedIn,
    isClientLoggedIn,
  }}
>
  {isReady ? children : null}
</UserContext.Provider>
  );
};

export const useAuth = () => React.useContext(UserContext);
